module.exports = __webpack_public_path__ + "img/product06-edu.12ee75e5.svg";